import { withAnchoredColumnFirst } from "ds/components/Table/Head/helpers";

import { syncColumnsOrder, toColumnIds } from "./syncColumnsOrder";
import { TableColumnsOrder, TableColumnsState } from "./types";

const mergeColumnsOrder = (
  persistedOrder: unknown,
  currentOrder: TableColumnsOrder,
  anchoredColumn?: string
): TableColumnsOrder => {
  if (!persistedOrder || typeof persistedOrder !== "object") {
    return currentOrder;
  }

  const persistedVisible = "visible" in persistedOrder ? persistedOrder.visible : undefined;
  const persistedHidden = "hidden" in persistedOrder ? persistedOrder.hidden : undefined;

  return withAnchoredColumnFirst(
    syncColumnsOrder(
      {
        visible: toColumnIds(persistedVisible),
        hidden: toColumnIds(persistedHidden),
      },
      currentOrder
    ),
    anchoredColumn
  );
};

const mergeColumnsSizes = (
  persistedSizes: unknown,
  currentState: TableColumnsState
): TableColumnsState["columnsSizes"] => {
  const nextSizes = { ...currentState.columnsSizes };

  if (!persistedSizes || typeof persistedSizes !== "object") {
    return nextSizes;
  }

  Object.entries(persistedSizes).forEach(([columnId, size]) => {
    if (columnId in currentState.columnsState && typeof size === "number") {
      nextSizes[columnId] = size;
    }
  });

  return nextSizes;
};

export const mergeTablePersistedState = <T extends TableColumnsState>(
  persistedState: unknown,
  currentState: T
): T => {
  if (!persistedState || typeof persistedState !== "object") {
    return currentState;
  }

  const persistedOrder = "columnsOrder" in persistedState ? persistedState.columnsOrder : undefined;
  const persistedSizes = "columnsSizes" in persistedState ? persistedState.columnsSizes : undefined;
  const persistedPinned =
    "isFirstColumnPinned" in persistedState ? persistedState.isFirstColumnPinned : undefined;

  return {
    ...currentState,
    columnsOrder: mergeColumnsOrder(
      persistedOrder,
      currentState.columnsOrder,
      currentState.anchoredColumn
    ),
    columnsSizes: mergeColumnsSizes(persistedSizes, currentState),
    isFirstColumnPinned:
      typeof persistedPinned === "boolean" ? persistedPinned : currentState.isFirstColumnPinned,
  };
};
